var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app-bar',{attrs:{"flat":"","color":_vm.color,"dense":_vm.dense}},[(_vm.title)?_c('v-toolbar-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._t("left"),_c('v-spacer'),_vm._t("default")],2),_c('v-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }